var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as Icon from "backpack-ui/dist/components/icon";
import * as cn from "classnames";
import * as React from "react";
import { Indicator } from "../../../../components/indicator";
import * as styles from "./styles.css";
export var LinkShop = function (_a) {
    var _b = _a.hasItems, hasItems = _b === void 0 ? false : _b, _c = _a.href, href = _c === void 0 ? "https://shop.lonelyplanet.com/cart" : _c, className = _a.className, rest = __rest(_a, ["hasItems", "href", "className"]);
    return (React.createElement("a", __assign({}, rest, { className: cn(styles.linkShop, className), href: href, title: "View shopping cart", "aria-label": "View shopping cart" }),
        hasItems &&
            React.createElement(Indicator, { className: styles.linkShopIndicator, "aria-label": "Shopping cart has items" }),
        React.createElement(Icon.Cart, { className: styles.linkShopIcon })));
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/link/linkShop.tsx
// module id = mY+9
// module chunks = 2